import { API_PREFIX } from '@/config/api'
import type {
    ProductCreateModel,
    ProductModel,
    ProductUpdateModel
} from '@/types/models/ProductModel'
import { api } from '@rfc/rfc-components-library/helpers'
import type { PaginationType } from '@rfc/rfc-components-library/types'
import { buildQueryUrl } from '@rfc/rfc-components-library/utils'
import type { AxiosResponse } from 'axios'

const PRODUCTS_API_PREFIX = `${API_PREFIX}/products`

export type ProductsPaginationResponse = {
    data: ProductModel[]
    meta: {
        current_page: number
        last_page: number
        per_page: number
        total: number
        from: number | null
        to: number | null
    }
}

export type ProductFilters = {
    organization_id?: number
}

const productsApi = {
    getProducts: (
        params?: Partial<PaginationType & ProductFilters>
    ): Promise<ProductsPaginationResponse> =>
        api.get(`${PRODUCTS_API_PREFIX}${buildQueryUrl(params)}`).then(res => res.data),

    getProduct: (id: number): Promise<AxiosResponse<ProductModel>> =>
        api.get(`${PRODUCTS_API_PREFIX}/${id}`).then(res => res.data),

    createProduct: (data: ProductCreateModel): Promise<AxiosResponse<ProductModel>> =>
        api.post(PRODUCTS_API_PREFIX, data).then(res => res.data),

    updateProduct: (id: number, data: ProductUpdateModel): Promise<AxiosResponse<ProductModel>> =>
        api.patch(`${PRODUCTS_API_PREFIX}/${id}`, data).then(res => res.data),

    deleteProduct: (id: number): Promise<AxiosResponse<{ message: string }>> =>
        api.delete(`${PRODUCTS_API_PREFIX}/${id}`)
}

export default productsApi
